import { render, staticRenderFns } from "./AssignLock.vue?vue&type=template&id=4e8996b4"
import script from "./AssignLock.vue?vue&type=script&lang=js"
export * from "./AssignLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports